// eslint-disable-next-line import/prefer-default-export
export enum UserCategory {
    gaid = 'GAID',
    oaid = 'OAID',
    lmt = 'LMT',
    not_lmt = '!LMT',
}
